import { Signal } from "@preact/signals";
import { MediaType, Size } from "./interfaces";

export const renderImageArea = (
    canvas: HTMLCanvasElement,
    ctx: CanvasRenderingContext2D,
    img: HTMLImageElement,
    mx: number,
    my: number,
) => {
    const pxr = img.naturalWidth / img.width;
    const w = canvas.width;
    const h = canvas.height;
    const nx = Math.max(0, Math.min(img.naturalWidth - w, mx * pxr - w / 2));
    const ny = Math.max(0, Math.min(img.naturalHeight - h, my * pxr - h / 2));
    const ax = nx / pxr;
    const ay = ny / pxr;
    const aw = w / pxr;
    const ah = h / pxr;

    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(img, nx, ny, w, h, 0, 0, w, h);

    return {
        x: ax + img.offsetLeft,
        y: ay + img.offsetTop,
        width: aw,
        height: ah,
    };
};

export const renderPdfArea = (
    preview: HTMLDivElement,
    previewSize: { width: number; height: number },
    mx: number,
    my: number,
    zoomScale: number,
    size: { width: number; height: number },
) => {
    const aw = previewSize.width / zoomScale;
    const ah = previewSize.height / zoomScale;
    const ax = Math.max(0, Math.min(size.width - aw, mx - aw / 2));
    const ay = Math.max(0, Math.min(size.height - ah, my - ah / 2));
    const tx = -ax * zoomScale;
    const ty = -ay * zoomScale;

    const wrapper = preview.querySelector<HTMLDivElement>(
        "[data-document-wrapper]",
    );

    if (wrapper) {
        wrapper.style.transform = `translate(${tx}px, ${ty}px)`;
    }

    return {
        x: ax,
        y: ay,
        width: aw,
        height: ah,
    };
};

export const getAnimationParams = (
    type: MediaType,
    pageSize: Size | undefined,
    sizeSignal: Signal<Size>,
    img: HTMLImageElement | null,
) => {
    if (type === "pdf") {
        return {
            page: pageSize ?? {
                width: sizeSignal.value.width,
                height: sizeSignal.value.height,
            },
            img: {
                width: sizeSignal.value.width,
                height: sizeSignal.value.height,
            },
            offset: {
                x: 0,
                y: 0,
            },
        };
    }

    return {
        page: pageSize ?? {
            width: img?.naturalWidth || 0,
            height: img?.naturalHeight || 0,
        },
        img: {
            width: img?.width || 0,
            height: img?.height || 0,
        },
        offset: {
            x: img?.offsetLeft || 0,
            y: img?.offsetTop || 0,
        },
    };
};
